import { useEffect, useState } from "react";
import { useRuntimeConstants } from "../../../context/runtimeConstants/RuntimeConstantsContext";
import { useProduct } from "../../../context/product/ProductContext";
import { getEarlyAccessToSaleContext } from "../../../utils/loyalty/getEarlyAccessToSaleContext";
import styles from "./PriceOnApp.scss";

const PriceOnApp = () => {
  const { getTranslation } = useRuntimeConstants();
  const { product } = useProduct();
  const [earlyAccessToSaleContext, setEarlyAccessSaleContext] = useState(null);

  useEffect(() => {
    if (!product) return;

    const fetchEarlyAccessToSaleContext = async () => {
      const { isEarlyAccessToSale, earlyAccessToSaleContext } =
        await getEarlyAccessToSaleContext(product);

      if (isEarlyAccessToSale) {
        setEarlyAccessSaleContext(earlyAccessToSaleContext);
      } else {
        setEarlyAccessSaleContext(null);
      }
    };

    fetchEarlyAccessToSaleContext();
  }, [product]);

  if (!product || !earlyAccessToSaleContext) {
    return null;
  }

  return (
    <p className={styles.price}>
      <span>{getTranslation("early_access_to_sale_price_on_app")}</span>
      <span>{` ${earlyAccessToSaleContext.current.text}`}</span>
      <span
        className={styles.discountPercentage}
      >{` (-${earlyAccessToSaleContext.discountPercentage}%)`}</span>
    </p>
  );
};

export default PriceOnApp;
